/* unplugin-vue-components disabled */import { render } from "./CommentForm.vue?vue&type=template&id=c218ed3e&scoped=true"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"

import "./CommentForm.vue?vue&type=style&index=0&id=c218ed3e&lang=scss&scoped=true"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c218ed3e"]])

export default __exports__